<template>
  <div class='InitInput' :style="{ width: width }">
    <div class="label">{{ label }} {{ required ? '*' : '' }} <span>{{ errorMsg }}</span></div>
    <div class="cont-input" :class="{ error: error }">
      <!-- Input Tipo texto -->
      <input v-if="type === 'text' && !Mask.length" :value="value" :placeholder="placeholder" :type="password ? 'password' : 'text'" @input="$emit('returnValue', $event.target.value)">
      <input v-if="type === 'text' && Mask.length > 0" v-mask="Mask" :value="value" :placeholder="placeholder" :type="password ? 'password' : 'text'" @input="e => $emit('returnValue', e.target.value)">
      <div class="textInput" v-if="textInput.length && type === 'text'">{{ textInput }}</div>
      <!-- Input tipo select -->
      <select v-if="type === 'select'" @change="e => $emit('returnValue', e.target.value)">
        <option
        v-for="(i, key) in options"
        :key="key"
        :value="i.value"
        >
          {{ i.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
  name: 'InitInput',
  directives: { mask: mask },
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    required: {
      type: Boolean,
      default: true
    },
    textInput: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    password: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => ([{ value: '', name: '' }])
    },
    Mask: {
      type: Array,
      default: () => ([])
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.InitInput {
  width: 100%;
  text-align: left;
}

.label {
  font-size: 12px;
  font-weight: bold;
}

.cont-input {
  display: flex;
  border: thin solid #CCCCCC;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 1px 1px 2px 0.5px #CCCCCC;
}

.error {
  border: thin solid red;
}

input {
  width: 100%;
  border: 0;
}

input:focus {
  outline: none;
}

.textInput {
  font-size: 12px;
}

select {
  width: 100%;
  border: 0;
  background-color: #FFFFFF;
}

select:focus {
  outline: none;
}

span {
  color: red
}
</style>
